import React from "react";
import { cn } from "@/lib/utils";

// Wordmark button (calm system): gradient branding kept, glow removed.
export const NeonLogo = ({ className, onClick, ...props }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            data-testid="site-header-logo"
            className={cn(
                "rf-heading rf-gradient-text inline-flex min-h-11 items-center rounded-md font-bold text-2xl sm:text-3xl",
                "transition-opacity hover:opacity-90",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400/70",
                className,
            )}
            {...props}
        >
            ReelFlo
        </button>
    );
};
